type LeadTrackingParams = {
  dealer_group_unique_name: string | null;
  dealer_group_uuid: string | null;
  dealer_name: null | string;
  dealer_unique_name: null | string;
  dealer_uuid: null | string;
  experience: string;
  id_from_provider: string;
  remote_dealer_id: string;
  remote_sku: string | null;
  rooftop_unique_name: string | null;
  rooftop_uuid: string | null;
};

export enum LeadTrackingPageSource {
  DesktopVdp = 'vdp',
  MobileVdp = 'mobile_vdp',
  DesktopVdpQuickPicks = 'vdp_quick_picks',
  MobileVdpQuickPicks = 'mobile_vdp_quick_picks',
  DesktopSrp = 'srp',
  MobileSeoSrp = 'mobile_seo_srp',
  MobileSrp = 'mobile_srp',
  DesktopSeoSrpQuickPicks = 'seo_srp_quick_picks',
  DesktopSrpQuickPicks = 'srp_quick_picks',
  MobileSeoSrpQuickPicks = 'mobile_seo_srp_quick_picks',
  MobileSrpQuickPicks = 'mobile_srp_quick_picks',
}

export default LeadTrackingParams;
